module.exports = __webpack_public_path__ + "static/img/6.7df8d7d8.png";